export enum MapActions {
    SelectObject = 'SelectObject',
    SelectMultipleObjects = 'SelectMultipleObjects',
    SelectMultipleObjectsByPolygon = 'SelectMultipleObjectsByPolygon',

    MeasureDistance = 'MeasureDistance',
    MeasureArea = 'MeasureArea',
    MeasureCircleRadius = 'MeasureCircleRadius',
}